// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectorExtra-module_rowContent__yNhiP {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Row/styles/selectorExtra.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,YAAY;AAChB","sourcesContent":[".rowContent {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowContent": `selectorExtra-module_rowContent__yNhiP`
};
export default ___CSS_LOADER_EXPORT___;
